var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Mise à jour des produits")]),_c('el-button',{attrs:{"type":"primary","icon":"fas fa-sync","circle":""},on:{"click":_vm.syncCatalogueAllnet}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }